<template>
    <div :class="`[ c-form-item ] u-flex-set u-margin-tiny ${ customClass ? customClass : ''}`">
        <label :for="name+_uid" class="[ c-checkbox ]">
            <input type="checkbox" class="[ c-checkbox__input ]" :name="name+_uid" :id="name+_uid"
                   :checked="value.IsSelected" @click="setSelectedItem">
            <span class="c-checkbox__label"  :style="value.IsSelected ? 'font-weight: 600': ''"><slot></slot></span>
        </label>
    </div>
</template>

<script>
    export default {
        props: ['name', 'customClass', 'value'],
        methods: {
            setSelectedItem () {
                this.$set(this.value, 'IsSelected', !this.value.IsSelected);
                this.$emit('item-selected', this.value.Value);
            }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/form/filters/FilterCheckboxElement.vue